

























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class DateRangeComponent extends Vue {
    @Prop() public value: { start: Date; end: Date };
    @Prop({ default: false }) public disabledDates: boolean;

    get isValid() {
        return (
            !!this.value &&
            !!this.value.start &&
            this.value.end &&
            this.value.start <= this.value.end
        );
    }

    get disabledDatesStart() {
        if (!this.value || !this.value.end || !this.disabledDates) {
            return {};
        }

        let current = new Date(+this.value.end);
        current.setDate(current.getDate());

        return {
            from: current
        };
    }

    get disabledDatesEnd() {
        if (!this.value || !this.value.start || !this.disabledDates) {
            return {};
        }

        let current = new Date(+this.value.start);
        current.setDate(current.getDate());

        return {
            to: current
        };
    }
}
